import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { FiBook, FiPlay, FiZap, FiCheckSquare, FiShield, FiGlobe } from 'react-icons/fi';

const LibraryStats = ({ modules = [] }) => {
  const active = modules.filter(m => m.status === 'Active').length;
  const draft = modules.filter(m => m.status === 'Draft').length;
  const totalUsage = modules.reduce((a, b) => a + (b.usageCount || 0), 0);
  const spanishCount = modules.filter(m => m.language === 'es').length;
  const englishCount = modules.filter(m => m.language === 'en').length;

  const stats = [
    { label: 'Total Modules', value: modules.length, icon: FiBook, color: 'bg-blue-50 text-blue-600', border: 'border-blue-100' },
    { label: 'Active', value: active, icon: FiPlay, color: 'bg-emerald-50 text-emerald-600', border: 'border-emerald-100' },
    { label: 'Drafts', value: draft, icon: FiZap, color: 'bg-amber-50 text-amber-600', border: 'border-amber-100' },
    { label: 'Total Assignments', value: totalUsage, icon: FiCheckSquare, color: 'bg-violet-50 text-violet-600', border: 'border-violet-100' },
    { label: 'English Modules', value: englishCount, icon: FiShield, color: 'bg-cyan-50 text-cyan-600', border: 'border-cyan-100' },
    { label: 'Módulos en Español', value: spanishCount, icon: FiGlobe, color: 'bg-yellow-50 text-yellow-600', border: 'border-yellow-100' },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
      {stats.map(s => (
        <div key={s.label} className={`bg-white rounded-xl border ${s.border} shadow-sm p-4 flex flex-col gap-2`}>
          <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${s.color}`}>
            <SafeIcon icon={s.icon} className="text-base" />
          </div>
          <div className="text-2xl font-bold text-slate-800">{s.value}</div>
          <div className="text-xs font-medium text-slate-500">{s.label}</div>
        </div>
      ))}
    </div>
  );
};

export default LibraryStats;